import i18n from '@/shared/i18n';
import cloneDeep from 'lodash/cloneDeep';
import BaseModel from '@/core/components/input-widget/BaseModel';
import VendorChargeDataModel from './VendorChargeData.model';

export default class VendorChargeModel extends BaseModel {
  constructor(data = {}) {
    super();
    Object.assign(this, {
      name: data.name,
      level: data.level,
      is_overridden: !!data.source_uuid,
      data: new VendorChargeDataModel(data.data)
    });
  }

  rules = {
    name_dropdown_value: 'required',
  };

  attributeLabels = {
    name: i18n.t('Name'),
    name_dropdown_value: i18n.t('Name')
  };

  toJSON() {
    let data = cloneDeep(super.toJSON());
    return data;
  }
}
